import styles from "./PackageDetailLoader.module.css";

export default function PackageDetailLoader() {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonBadge} />
          <div className={styles.skeletonBadge} />
          <div className={styles.skeletonBadge} />
        </div>
        <div className={styles.headerActions}>
          <div className={styles.skeletonButton} />
          <div className={styles.skeletonButton} />
          <div className={styles.skeletonButton} />
        </div>
      </div>

      <div className={styles.content}>
        <div className={`${styles.section} ${styles.sectionPackageInfo}`}>
          <div className={styles.skeletonSectionTitle} />
          <div className={styles.infoGrid}>
            <div className={styles.infoItem}>
              <div className={styles.skeletonLabel} />
              <div className={styles.skeletonValue} />
            </div>
            <div className={styles.infoItem}>
              <div className={styles.skeletonLabel} />
              <div className={styles.skeletonValue} />
            </div>
            <div className={styles.infoItem}>
              <div className={styles.skeletonLabel} />
              <div className={styles.skeletonValue} />
            </div>
            <div className={styles.infoItem}>
              <div className={styles.skeletonLabel} />
              <div className={styles.skeletonValue} />
            </div>
          </div>
        </div>

        <div className={`${styles.section} ${styles.sectionFeatures}`}>
          <div className={styles.skeletonSectionTitle} />
          <div className={styles.featureList}>
            <div className={styles.skeletonFeatureChip} />
            <div className={styles.skeletonFeatureChip} />
            <div className={styles.skeletonFeatureChip} />
          </div>
        </div>

        <div className={`${styles.section} ${styles.sectionEmpty}`}>
          <div className={styles.skeletonSectionTitle} />
          <div className={styles.skeletonEmptyText} />
        </div>

        <div className={`${styles.section} ${styles.sectionEmpty}`}>
          <div className={styles.skeletonSectionTitle} />
          <div className={styles.skeletonEmptyText} />
        </div>

        <div className={`${styles.section} ${styles.sectionEmpty}`}>
          <div className={styles.skeletonSectionTitle} />
          <div className={styles.skeletonEmptyText} />
        </div>
      </div>
    </>
  );
}
